import axios from 'axios';
import qs from 'qs';

let base = 'http://alphago.chemucao.cn/';
let sub = 'real/api/index.php';

// 查询商圈
export const bizcycleDeal = (params, cb) => { return axios.post(`${base}${sub}/bizcycle/deal`, qs.stringify(params)).then(res => { console.debug("bizcycleDeal> res:%o", res); cb(res.data) }); };
// 附近商圈
export const bizcycleNearby = (params, cb) => { return axios.post(`${base}${sub}/bizcycle/nearby`, qs.stringify(params)).then(res => { console.debug("bizcycleNearby> res:%o", res); if(res.data.code === 0){cb(res.data.data)} }); };
//查询城市
export const cityDeal = (params, cb) => { return axios.post(`${base}${sub}/city/deal`, qs.stringify(params)).then(res => { console.debug("cityDeal> res:%o", res); cb(res.data) }); };
// 查询小区 ok
export const comDeal = (params, cb) => { return axios.post(`${base}${sub}/community/deal`, qs.stringify(params)).then(res => { console.debug("comDeal> res.data:%o", res.data); cb(res.data) }); };
// 附近小区
export const comNearby = (params, cb) => { return axios.post(`${base}${sub}/community/nearby`, qs.stringify(params)).then(res => { console.debug("comNearby> res:%o", res); if(res.data.code === 0){cb(res.data.data)} }); };
// 查询区县
export const distDeal = (params, cb) => { return axios.post(`${base}${sub}/district/deal`, qs.stringify(params)).then(res => { console.debug("distDeal> res:%o", res); cb(res.data) }); };
// 附近区县
export const distNearby = (params, cb) => { return axios.post(`${base}${sub}/district/nearby`, qs.stringify(params)).then(res => { console.debug("distNearby> res:%o", res); if(res.data.code === 0){cb(res.data.data)} }); };
// 签名 ok
export const jsapiSign = (params, cb) => { return axios.post(`${base}${sub}/jsapi/sign`, qs.stringify(params)).then(res => { if(res.data.code === 0){cb(res.data.data)} }); };
// 登录/注册 ok
export const userLogin = (params, cb, errcb) => { return axios.post(`${base}${sub}/user/login`, qs.stringify(params)).then(res => { console.debug("userLogin> res.data:%o", res.data); if(res.data.code === 0){cb(res.data.data)} else{errcb()} }); };
// 微信JS支付 ok
export const wxpayJsapi = (params, cb) => { return axios.post(`${base}${sub}/wxpay/jsapi`, qs.stringify(params)).then(res => { if(res.data.code === 0){cb(res.data.data)} }); };
// 支付通知
export const wxpayNotify = (params, cb) => { return axios.post(`${base}${sub}/wxpay/notify`, qs.stringify(params)).then(res => { console.debug("wxpayNotify> res:%o", res); if(res.data.code === 0){cb(res.data.data)} }); };






// WEBPACK FOOTER //
// ./src/api/alphago.js